/* Emociones a Domicilio — interacciones del tema */
(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const debounce = (fn, ms) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };
  const postJSON = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => {
      if (!r.ok) throw new Error('Request failed');
      return r.json();
    });

  /* ---------- Barra de anuncios (rotación) ---------- */
  function initAnnouncement() {
    const items = $$('.announcement__item');
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- Encabezado ---------- */
  function initHeader() {
    const header = $('[data-header]');
    if (header) {
      const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    // Cierra los submenús al hacer clic fuera
    document.addEventListener('click', (e) => {
      $$('[data-dropdown][open]').forEach((d) => {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
    $$('[data-dropdown]').forEach((d) =>
      d.addEventListener('toggle', () => {
        if (d.open) $$('[data-dropdown][open]').forEach((o) => o !== d && o.removeAttribute('open'));
      })
    );

    // Menú móvil
    const menu = $('[data-menu]');
    const openBtn = $('[data-menu-open]');
    if (menu && openBtn) {
      const close = () => {
        menu.hidden = true;
        openBtn.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        openBtn.focus();
      };
      openBtn.addEventListener('click', () => {
        menu.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
      $$('[data-menu-close]', menu).forEach((b) => b.addEventListener('click', close));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !menu.hidden) close();
      });
    }

    // Buscador desplegable
    const searchBtn = $('[data-search-open]');
    const searchBar = $('[data-search-bar]');
    if (searchBtn && searchBar) {
      searchBtn.addEventListener('click', (e) => {
        e.preventDefault();
        searchBar.hidden = !searchBar.hidden;
        if (!searchBar.hidden) $('input[type="search"]', searchBar).focus();
      });
    }
  }

  /* ---------- Selectores de cantidad ---------- */
  function initQty() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!btn) return;
      const input = $('input', btn.closest('[data-qty]'));
      const min = parseInt(input.min || '0', 10);
      const value = parseInt(input.value || '0', 10) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
      input.value = Math.max(min, value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Producto: galería y variantes ---------- */
  function initProduct() {
    const root = $('[data-product]');
    if (!root) return;

    const slides = $$('[data-gallery-slide]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    const show = (index) => {
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.gallerySlide === String(index)));
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.galleryThumb === String(index)));
    };
    thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.galleryThumb)));

    const variantsEl = $('[data-variants]', root);
    if (!variantsEl) return;
    const variants = JSON.parse(variantsEl.textContent);
    const selects = $$('[data-option-index]', root);
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-button]', root);
    const priceEl = $('[data-price-current]', root);
    const compareEl = $('[data-price-compare]', root);
    const money = (cents) =>
      new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100);

    selects.forEach((sel) =>
      sel.addEventListener('change', () => {
        const chosen = selects.map((s) => s.value);
        const variant = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
        if (!variant) {
          addBtn.disabled = true;
          addBtn.textContent = 'No disponible';
          return;
        }
        idInput.value = variant.id;
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
        priceEl.textContent = money(variant.price);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !onSale;
        if (onSale) compareEl.textContent = money(variant.compare_at_price);
        if (variant.featured_media) {
          const idx = slides.findIndex((s, i) => i === variant.featured_media.position - 1);
          if (idx > -1) show(idx);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      })
    );
  }

  /* ---------- Recomendaciones de producto ---------- */
  function initRecommendations() {
    const el = $('[data-recommendations]');
    if (!el || !el.dataset.url) return;
    fetch(el.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  }

  /* ---------- Colección: ordenar ---------- */
  function initSort() {
    const sel = $('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Reglas de entrega (hora de CDMX) ---------- */
  const Delivery = (function () {
    const cfg = (window.Emociones && window.Emociones.delivery) || {};
    const TZ = 'America/Mexico_City';
    const toMinutes = (hhmm) => {
      const [h, m] = String(hhmm || '0:0').split(':').map((n) => parseInt(n, 10) || 0);
      return h * 60 + m;
    };
    const slots = (cfg.slots || []).map((s) => {
      const [start, end] = String(s.time).split('-');
      return { id: s.id, label: s.label, start: toMinutes(start), end: toMinutes(end), time: `${start.trim()} – ${end.trim()}` };
    });
    const sameDayCutoff = toMinutes(cfg.sameDayCutoff || '14:00');
    const leadMinutes = (cfg.leadHours || 4) * 60;
    const nextDayCutoff = (cfg.nextDayCutoff || 20) * 60;

    // Fecha y minutos actuales en CDMX, sin importar la zona horaria del cliente
    function nowParts() {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
          .formatToParts(new Date())
          .map((p) => [p.type, p.value])
      );
      return { iso: `${parts.year}-${parts.month}-${parts.day}`, minutes: parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10) };
    }
    function addDays(iso, n) {
      const [y, m, d] = iso.split('-').map(Number);
      const dt = new Date(Date.UTC(y, m - 1, d + n));
      return dt.toISOString().slice(0, 10);
    }
    function isSunday(iso) {
      const [y, m, d] = iso.split('-').map(Number);
      return new Date(Date.UTC(y, m - 1, d)).getUTCDay() === 0;
    }
    function slotAvailable(iso, slotId) {
      const slot = slots.find((s) => s.id === slotId);
      if (!slot) return false;
      if (cfg.blockSunday && isSunday(iso)) return false;
      const now = nowParts();
      if (iso < now.iso) return false;
      if (iso === now.iso) {
        // Mismo día: el horario 1 (matutino) cerró ayer a la hora límite, así que nunca se ofrece hoy.
        // Los demás, solo antes de la hora límite y con margen antes de que termine el horario.
        if (slot.id === slots[0].id) return false;
        if (now.minutes >= sameDayCutoff) return false;
        return slot.end - now.minutes >= leadMinutes;
      }
      if (iso === addDays(now.iso, 1)) {
        // Día siguiente: el primer horario (matutino) cierra a la hora límite; los demás siguen abiertos
        if (slot.id === slots[0].id) return now.minutes < nextDayCutoff;
        return true;
      }
      return true;
    }
    function dateSelectable(iso) {
      return slots.some((s) => slotAvailable(iso, s.id));
    }
    function minDate() {
      const today = nowParts().iso;
      for (let i = 0; i < 21; i++) {
        const iso = addDays(today, i);
        if (dateSelectable(iso)) return iso;
      }
      return addDays(today, 1);
    }
    const labelFor = (id) => {
      const s = slots.find((x) => x.id === id);
      return s ? `${s.label} (${s.time})` : '';
    };
    const idFromLabel = (label) => {
      const s = slots.find((x) => labelFor(x.id) === label || x.id === label);
      return s ? s.id : '';
    };
    return { slots, slotAvailable, dateSelectable, minDate, labelFor, idFromLabel, isSunday, nowParts };
  })();

  /* ---------- Carrito ---------- */
  function initCart() {
    const form = $('[data-cart-form]');
    if (!form) return;
    const routes = window.Emociones.routes;
    const status = $('[data-cart-status]', form);
    const errorEl = $('[data-cart-error]', form);
    const setStatus = (msg) => status && (status.textContent = msg);

    // Cantidades: envía el formulario para recalcular
    $$('[data-cart-qty]', form).forEach((input) =>
      input.addEventListener(
        'change',
        debounce(() => {
          setStatus('Actualizando…');
          const action = document.createElement('input');
          action.type = 'hidden';
          action.name = 'update';
          action.value = '1';
          form.appendChild(action);
          form.submit();
        }, 450)
      )
    );

    // Entrega
    const dateInput = $('[data-delivery-date]', form);
    const dateHint = $('[data-delivery-date-hint]', form);
    const slotWrap = $('[data-slots]', form);
    const slotHint = $('[data-delivery-slot-hint]', form);
    const attrDate = $('[data-attr-date]', form);
    const attrSlot = $('[data-attr-slot]', form);
    let selectedSlot = Delivery.idFromLabel(attrSlot.value);

    slotWrap.innerHTML = Delivery.slots
      .map((s) => `<button type="button" class="slot" data-slot="${s.id}" aria-pressed="false"><strong>${s.label}</strong><span>${s.time}</span></button>`)
      .join('');
    const slotButtons = $$('.slot', slotWrap);

    const min = Delivery.minDate();
    dateInput.min = min;
    if (!dateInput.value || dateInput.value < min) {
      dateInput.value = min;
      selectedSlot = '';
    }

    function refreshSlots() {
      const iso = dateInput.value;
      let any = false;
      slotButtons.forEach((b) => {
        const ok = iso ? Delivery.slotAvailable(iso, b.dataset.slot) : false;
        b.disabled = !ok;
        if (!ok && b.dataset.slot === selectedSlot) selectedSlot = '';
        b.setAttribute('aria-pressed', String(ok && b.dataset.slot === selectedSlot));
        if (ok) any = true;
      });
      slotHint.hidden = any;
      if (!any) slotHint.textContent = 'No quedan horarios para esta fecha. Elige otro día.';
      attrDate.value = iso || '';
      attrSlot.value = Delivery.labelFor(selectedSlot);
    }

    const saveAttributes = debounce(() => {
      setStatus('Guardando…');
      const occasion = $('[name="attributes[Ocasión]"]', form);
      postJSON(routes.cartUpdate, {
        note: $('[data-note]', form).value,
        attributes: {
          'Fecha de entrega': attrDate.value,
          'Horario de entrega': attrSlot.value,
          'Ocasión': occasion ? occasion.value : '',
        },
      })
        .then(() => setStatus('Guardado ✓'))
        .catch(() => setStatus('No se pudo guardar. Se guardará al finalizar la compra.'));
    }, 600);

    dateInput.addEventListener('change', () => {
      dateHint.hidden = true;
      dateHint.classList.remove('field__hint--error');
      if (dateInput.value && Delivery.isSunday(dateInput.value) && !Delivery.dateSelectable(dateInput.value)) {
        dateHint.textContent = 'No hacemos entregas en domingo. Elige otro día.';
        dateHint.hidden = false;
        dateHint.classList.add('field__hint--error');
      } else if (dateInput.value && dateInput.value < dateInput.min) {
        dateHint.textContent = 'Esa fecha ya no está disponible.';
        dateHint.hidden = false;
        dateHint.classList.add('field__hint--error');
      }
      refreshSlots();
      saveAttributes();
    });

    slotWrap.addEventListener('click', (e) => {
      const b = e.target.closest('.slot');
      if (!b || b.disabled) return;
      selectedSlot = b.dataset.slot;
      errorEl.hidden = true;
      refreshSlots();
      saveAttributes();
    });

    refreshSlots();
    // Revisa disponibilidad cada minuto para que una selección no caduque sin aviso
    setInterval(refreshSlots, 60000);

    // Dedicatoria y ocasión
    const note = $('[data-note]', form);
    const noteCount = $('[data-note-count]', form);
    $$('[data-autosave]', form).forEach((el) =>
      el.addEventListener(el.tagName === 'SELECT' ? 'change' : 'input', () => {
        if (el === note && noteCount) noteCount.textContent = note.value.length;
        saveAttributes();
      })
    );

    // Observación por producto (propiedad de la línea)
    $$('[data-observation]', form).forEach((input) =>
      input.addEventListener(
        'input',
        debounce(() => {
          const key = input.dataset.observation;
          setStatus('Guardando…');
          fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } })
            .then((r) => r.json())
            .then((cart) => {
              const line = cart.items.find((i) => i.key === key);
              if (!line) return null;
              const properties = Object.assign({}, line.properties);
              if (input.value.trim()) properties['Observación'] = input.value.trim();
              else delete properties['Observación'];
              return postJSON(routes.cartChange, { id: key, quantity: line.quantity, properties });
            })
            .then((cart) => {
              setStatus('Guardado ✓');
              // La llave de la línea cambia cuando cambian sus propiedades
              if (cart && cart.items) {
                const updated = cart.items.find((i) => i.properties && i.properties['Observación'] === input.value.trim());
                if (updated) {
                  input.dataset.observation = updated.key;
                  const li = input.closest('[data-line]');
                  if (li) li.dataset.line = updated.key;
                }
              }
            })
            .catch(() => setStatus('No se pudo guardar la observación.'));
        }, 700)
      )
    );

    // Validación antes de pagar
    form.addEventListener('submit', (e) => {
      const submitter = e.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      refreshSlots();
      if (!attrDate.value || !selectedSlot || !Delivery.slotAvailable(attrDate.value, selectedSlot)) {
        e.preventDefault();
        errorEl.textContent = 'Elige la fecha y el horario de entrega para continuar.';
        errorEl.hidden = false;
        $('[data-delivery]', form).scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  /* ---------- Ayuda con la dedicatoria (IA o ideas listas) ---------- */
  const IDEAS = {
    romantico: [
      'Cada día a tu lado es mi regalo favorito. Te amo, {to}.',
      '{to}, gracias por hacer de mi vida la historia más bonita. Contigo, siempre.',
      'Si tuviera que elegir otra vez, te elegiría a ti, {to}. Una y mil veces.',
    ],
    emotivo: [
      '{to}, eres de esas personas que hacen el mundo más bonito. Gracias por existir.',
      'Para que hoy sepas lo importante que eres para mí, {to}. Con todo mi cariño.',
      'Hay personas que llegan para quedarse en el corazón. Tú eres una de ellas, {to}.',
    ],
    divertido: [
      '{to}: este regalo no viene con instrucciones, solo con mucho cariño (y calorías).',
      'Aviso oficial: hoy está prohibido no sonreír, {to}. Disfruta tu sorpresa.',
      '{to}, te mereces todo… pero por ahora empieza con esto. ¡Te quiero!',
    ],
    agradecido: [
      '{to}, gracias por estar siempre. Este detalle es poco para todo lo que das.',
      'Gracias por tu apoyo, tu tiempo y tu cariño, {to}. Esto es para ti.',
      'Para {to}, con todo mi agradecimiento. Lo que haces deja huella.',
    ],
    formal: [
      'Estimado(a) {to}: reciba este detalle con nuestro más sincero aprecio.',
      '{to}, con nuestro agradecimiento por su confianza. Le deseamos un excelente día.',
      'Para {to}, con un cordial saludo y nuestros mejores deseos.',
    ],
  };
  const OCCASION_LINES = {
    'Cumpleaños': '¡Feliz cumpleaños!',
    'Aniversario': '¡Feliz aniversario!',
    'Amor': '',
    'Agradecimiento': '',
    'Amistad': 'Por muchos años más de amistad.',
    'Corporativo': '',
  };

  function initAi() {
    const panel = $('[data-ai]');
    const toggle = $('[data-ai-toggle]');
    if (!panel || !toggle) return;
    const cfg = (window.Emociones && window.Emociones.ai) || {};
    const note = $('[data-note]');
    const optionsEl = $('[data-ai-options]', panel);
    const statusEl = $('[data-ai-status]', panel);
    const button = $('[data-ai-generate]', panel);
    const escapeHTML = (t) => t.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    toggle.addEventListener('click', () => {
      panel.hidden = !panel.hidden;
      toggle.setAttribute('aria-expanded', String(!panel.hidden));
      if (!panel.hidden) $('[data-ai-to]', panel).focus();
    });

    const read = () => {
      const occasionEl = $('[name="attributes[Ocasión]"]');
      return {
        to: $('[data-ai-to]', panel).value.trim(),
        from: $('[data-ai-from]', panel).value.trim(),
        tone: $('[data-ai-tone]', panel).value,
        detail: $('[data-ai-detail]', panel).value.trim(),
        occasion: occasionEl ? occasionEl.value : '',
      };
    };

    function localIdeas(input) {
      const list = IDEAS[input.tone] || IDEAS.emotivo;
      const lead = OCCASION_LINES[input.occasion] || '';
      return list.map((t) => {
        let msg = input.to
          ? t.replace(/\{to\}/g, input.to)
          : t.replace(/^\{to\}[,:]\s*/, '').replace(/,\s*\{to\}/g, '').replace(/Para \{to\}/g, 'Para ti').replace(/\s\{to\}/g, '');
        msg = msg.charAt(0).toUpperCase() + msg.slice(1);
        if (lead) msg = `${lead} ${msg}`;
        if (input.from) msg += ` — ${input.from}`;
        return msg.slice(0, 300);
      });
    }

    function render(options, isAi) {
      optionsEl.innerHTML = options
        .map((o) => `<button type="button" class="ai__option" data-ai-pick>${escapeHTML(o)}<small>Usar este mensaje</small></button>`)
        .join('');
      $$('[data-ai-pick]', optionsEl).forEach((b, i) =>
        b.addEventListener('click', () => {
          note.value = options[i].slice(0, 300);
          note.dispatchEvent(new Event('input', { bubbles: true }));
          statusEl.textContent = 'Listo. Puedes editar el mensaje a tu gusto.';
          note.focus();
        })
      );
      statusEl.textContent = isAi ? 'Elige una opción o vuelve a generar.' : 'Ideas sugeridas. Elige una y ajústala a tu gusto.';
    }

    button.addEventListener('click', async () => {
      const input = read();
      if (!cfg.endpoint) {
        render(localIdeas(input), false);
        return;
      }
      button.disabled = true;
      statusEl.textContent = 'Escribiendo opciones…';
      optionsEl.innerHTML = '';
      try {
        const res = await fetch(cfg.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(input),
        });
        const data = await res.json();
        if (!res.ok || !Array.isArray(data.options) || !data.options.length) throw new Error(data.error || 'sin opciones');
        render(data.options, true);
      } catch (err) {
        render(localIdeas(input), false);
        statusEl.textContent = 'La IA no respondió; te dejamos ideas sugeridas.';
      } finally {
        button.disabled = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAnnouncement();
    initHeader();
    initQty();
    initProduct();
    initRecommendations();
    initSort();
    initCart();
    initAi();
  });
})();
